import api from './api';

/**
 * Content Service
 * Handles tutorials, FAQs, and notary offices API calls
 */
const contentService = {
    // ==================== Tutorials ====================
    
    /**
     * Get all tutorials
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getTutorials: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/tutorials${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get tutorial by ID
     * @param {string} id - Tutorial ID
     * @returns {Promise<Object>}
     */
    getTutorialById: async (id) => {
        return api.get(`/user/tutorials/${id}`);
    },

    // ==================== FAQs ====================
    
    /**
     * Get all FAQs
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getFAQs: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/faqs${queryString ? `?${queryString}` : ''}`);
    },

    // ==================== Notary Offices ====================
    
    /**
     * Get all notary offices
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getNotaryOffices: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/notary-offices${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get notary office by ID
     * @param {string} id - Office ID
     * @returns {Promise<Object>}
     */
    getNotaryOfficeById: async (id) => {
        return api.get(`/user/notary-offices/${id}`);
    }
};

export default contentService;
